import { useToast } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { isFetchBaseQueryError } from 'rtkQuery/isFetchBaseQueryError';
import { isSharesproFetchQueryError } from 'rtkQuery/sharespro/isSharesproFetchQueryError';
import { isErrorWithMessage } from 'utils/isErrorWithMessage';

const useToastError = (): ((error: any) => void) => {
  const toast = useToast();
  const { t } = useTranslation();

  return (error: any) => {
    let message;
    if (isSharesproFetchQueryError(error)) {
      const errorData = error.data as any;
      message = errorData.error_message;
    } else if (isErrorWithMessage(error)) {
      message = error.message;
    } else if (isFetchBaseQueryError(error) && error.status === 'FETCH_ERROR') {
      message = t('checkYourConnectionError');
    }
    toast({
      title: t('error'),
      description: message,
      status: 'error',
      position: 'top-right',
      isClosable: true,
    });
  };
};

export default useToastError;
